ubBanzai = require 'ub/control/banzai-features'
_        = require 'lodash'
{safeSet, safeGet} = require 'ub/utils'

propertiesToInherit = [
  'style'
  'geometry.cornerRadius'
  'geometry.size.height'
]

getNonImageButtons = (page) ->
  page
    .getElementsByType 'lp-pom-button'
    .reject (element) ->
      _.any element.page.breakpoints, (breakpoint) ->
        element.model.safeGet('style.fillType', breakpoint) is 'image'

getLastButton = ->
  # Get the last button that was added to the current page. If there is no button on this
  # page, check other subpages.

  if window.editor?.page
    _.last(getNonImageButtons(window.editor.page)) or
      _(window.editor.pages)
        .reverse() # So we prioritise the main page over sub pages
        .map getNonImageButtons
        .flatten true
        .last()

inheritLastButtonStyle = (page, defaults) ->
  return unless ubBanzai.features.isButtonsInheritStylesEnabled()

  lastButton = getLastButton()
  return unless lastButton

  desktop = lastButton.page.getBreakpointByName 'desktop'
  mobile  = lastButton.page.getBreakpointByName 'mobile'

  # Iterate through properties and clone desktop and mobile properties
  for accessor in propertiesToInherit
    desktopValue = safeGet lastButton.model.getBasicBreakpointModel(desktop), accessor
    safeSet defaults, accessor, desktopValue

    # We use `getBasicBreakpointModel` to get just the properties that are distinct on
    # mobile and only copy those over to the mobile breakpoint defaults. This ensures that
    # on the new button, sub-properties that are not distinct on mobile maintain their
    # link to desktop.
    if lastButton.model.existsByBreakpoint accessor, mobile
      mobileValue = safeGet lastButton.model.getBasicBreakpointModel(mobile), accessor
      safeSet defaults, 'breakpoints.mobile.' + accessor, mobileValue


module.exports = inheritLastButtonStyle



// WEBPACK FOOTER //
// ./src/control/inherit-button-style.coffee